import React,{useState,useEffect} from "react";
import {Link} from "react-router-dom";
import ImageWithBasePath from "../../../../../core/img";
import {all_routes} from "../../../../router/all_routes";
import Table from "../../../../../core/dataTable/non-pager/index";
import Order_Payment_Edit_Modal from "./orderPaymentEditModal";
import Order_Status_Edit_Modal from "./orderStatusEditModal";
import {Toaster} from 'react-hot-toast';
/* -- biz9 import start -- */
import {UrlQuery} from "biz9-react-utility";
import {DateTime,Str,Log} from "biz9-utility";
import {Image_Format} from "biz9-image";
import {User_Logic,User_Table} from "biz9-user";
import {Order_Logic,Store_Service} from "biz9-store";
import {Portal_Table,Portal_Remote_Store_Order,Portal_Url,Portal_Type} from "biz9-portal-app";
import {Message,Type,Url,Field,Title} from "../../../../../constant";
import {App,Data,Dashboard,Event,Field_Logic,Image,Style,Service_Industry,User,Template,Toast_Message,Storage,System} from "../../../../../project";
import {Data_Logic} from "biz9-data-app";
/* -- biz9 import end -- */
const Dashboard_Admin_Order_Detail = () => {
    const query = UrlQuery();
    const [val_sub_page_title,setValSubPageTitle] = useState(Str.get_table_by_name(Portal_Table.ORDER));
    const [val_order_number,setValOrderNumber] = useState(query.get('order_number'));
    const [val_order_status,setValOrderStatus] = useState("");
    const [user,setUser] = useState(Data_Logic.get(Portal_Table.USER,0));
    const [order,setOrder] = useState(Data_Logic.get(Portal_Table.ORDER,0));
    const [order_items,setOrderItems] = useState([]);
    const [order_payments,setOrderPayments] = useState([]);
    const [order_sub_items,setOrderSubItems] = useState([]);
    const order_item_columns = [
    {
title: "Title",
           dataIndex: "title",
           render: (text: string, record: any) => (
                   <>
                   {record.parent.title}
                   </>
                   )
    },
    {
title: "Type",
           dataIndex: "type",
           render: (text: string, record: any) => (
                   <>
                   {record.parent.type}
                   </>
                   )
    },
 {
title: "Category",
           dataIndex: "category",
           render: (text: string, record: any) => (
                   <>
                   {record.parent.category}
                   </>
                   )
    },
    {
title: "Cost",
       dataIndex: "cost",
       render: (text: string, record: any) => (
               <>
               {Str.get_money(record.parent.cost)}
               </>
               )
    },
    {
title: "Quanity",
       dataIndex: "quanity",
       render: (text: string, record: any) => (
               <>
               {record.quanity}
               </>
               )
    },
    ];
    const order_payment_list_columns = [
    {
title: "Payment Amount",
           dataIndex: "payment_amount",
           key: "payment_amount",
           render: (text: string, record: any) => (
                   <>
                   {Str.get_money(record.payment_amount)}
                   </>
                   )
    },
    {
title: "Payment Method Type",
       dataIndex: "payment_method_type",
       key: "payment_method_type",
       render: (text: string, record: any) => (
               <>
               {record.payment_method_type}
               </>
               )
    },
{
    title: "Date & Time",
       dataIndex: "date_create",
       key: "date_create",
    render: (text: string, record: any) => (
            <>
            {DateTime.get_date(record.date_create)}{" "}
            {DateTime.get_time(record.date_create)}
            </>
        )
    },
    {
title: "Transaction ID",
       dataIndex: "transaction_id",
       key: "transaction_id",
       render: (text: string, record: any) => (
               <>
               {record.transaction_id}
               </>
               )
    },
    ];
  const order_sub_item_list_columns = [
    {
title: "Title",
           dataIndex: "title",
           render: (text: string, record: any) => (
                   <>
                   {record.parent.title}
                   </>
                   )
    },
 {
title: "Type",
           dataIndex: "type",
           render: (text: string, record: any) => (
                   <>
                   {record.parent.type}
                   </>
                   )
    },
 {
title: "Category",
           dataIndex: "category",
           render: (text: string, record: any) => (
                   <>
                   {record.parent.category}
                   </>
                   )
    },



    {
title: "Cost",
       dataIndex: "cost",
       render: (text: string, record: any) => (
               <>
               {Str.get_money(record.parent.cost)}
               </>
               )
    },
    {
title: "Quanity",
       dataIndex: "quanity",
       render: (text: string, record: any) => (
               <>
               {record.quanity}
               </>
               )
    },
    ];
    useEffect(() => {
           Toast_Message.loading(Message.LOADING);
         if(!Str.check_is_null(val_order_number)){
            get_data();
            }
    },[val_order_number]);
    async function btn_post_app() {

    };
    async function get_data() {
        const [response,data] = await Portal_Remote_Store_Order.get(App.get_url(Portal_Url.STORE_ORDER_GET),val_order_number);
        bind_items(data);
        Toast_Message.dismiss();
    }
    async function bind_items(data){
        // --  user --
        setUser(data[Portal_Type.ORDER][Portal_Type.USER]);
        // -- order --
        setOrder(data[Portal_Type.ORDER]);
        // -- order-items --
        setOrderItems(data[Portal_Type.ORDER][Portal_Type.ORDER_ITEMS]);
        // -- order-payments --
        setOrderPayments(data[Portal_Type.ORDER][Portal_Type.ORDER_PAYMENTS]);
        // -- order-value --
        setValOrderStatus(Order_Logic.get_status_types(data[Portal_Type.ORDER].status_type).title);
        // -- order-sub-items --
        let sub_items = [];
        for(const order_item of data[Portal_Type.ORDER][Portal_Type.ORDER_ITEMS]){
            for(const order_sub_item of order_item.order_sub_items){
                sub_items.push(order_sub_item);
            }
        }
        setOrderSubItems(sub_items);
    };
    const updateOrderStatus = (item) => {
        setValOrderStatus(item.status_type);
    };
    return (
            <>
            <Toaster />
            {/* Page Content */}
            <div className="page-wrapper">
            <div className="page-content content">
            <div className="row justify-content-center">
            <div className="col-xl-10">
            <div className="main-title mb-4">
            <h4>{val_sub_page_title}</h4>
            </div>
<ul className="nav nav-tabs nav-tabs-bottom mb-4">
<li className="nav-item">
<Link to={all_routes.dashboard_admin_order} className="nav-link" >
{"<- Back"}
</Link>
</li>
</ul>
            {/* CARD CONTENT-START */}
            <div className="card profile-card">
            <div className="card-body">
            <div className="d-flex align-items-center gap-3 justify-content-between flex-wrap">
            <div className="d-flex align-items-center flex-shrink-0">
            <Link to={all_routes.dashboard_user_profile_detail+"?user_id="+user.id} >
            <span className="avatar avatar-lg">
            <ImageWithBasePath className="rounded-2" src={Image.get_url(user.image_filename,Image_Format.SQUARE_THUMB)} alt="img" />
            </span>
            </Link>
            <div className="ms-3">
            <Link to={all_routes.dashboard_user_profile_detail+"?user_id="+user.id} >
            <h6 className="mb-1 d-inline-flex flex-wrap align-items-center">
            {user.username?user.username:"N/A"}
            </h6>
            </Link>
                <p className="mb-2">{user.email}</p>
                <p className="mb-2">{User_Logic.get_country_state_city(user)}</p>
                </div>
                </div>
                <Link to={"#"} onClick={() => btn_post_app()}  className="btn btn-lg btn-dark">
                App
                </Link>
                </div>
                </div>
                </div>
                {/* CARD CONTENT-END */}

             {/* CARD CONTENT-PROFILE-START */}
                <div className="card profile-details">
                <div className="card-header">
                <h5 style={{float:'left'}} className="mb-0">Order Details</h5>
                   <Link style={{float:'right'}} to={"#"} data-bs-toggle="modal" data-bs-target="#order_status_edit_modal" className="btn btn-lg btn-dark mb-0">
                            Edit
                            </Link>
                </div>
                <div className="card-body">
                <div className="row row-gap-3">
                <div className="col-md-4 col-sm-6">
                <h6>Order Number</h6>
                <p className="mb-0">{order.order_number}</p>
                </div>
                <div className="col-md-4 col-sm-6">
                <h6>Date & Time</h6>
                <p className="mb-0">{DateTime.get_date(order.date_create)}{" "}{DateTime.get_time(order.date_create)}</p>
                </div>
                <div className="col-md-4 col-sm-6">
                <h6>Grand Total</h6>
                <p className="mb-0">{Str.get_money(order.grand_total)}</p>
                </div>
                <div className="col-md-4 col-sm-6">
                <h6>Payment Plan</h6>
                <p className="mb-0">{order.payment_plan_type}</p>
                </div>
                <div className="col-md-4 col-sm-6">
                <h6>Status</h6>
                <p className="mb-0">{Str.get_table_by_name(val_order_status)}</p>
                </div>
                <div className="col-md-4 col-sm-6">
                <h6>Blank</h6>
                <p className="mb-0">blank</p>
                </div>
                </div>
                </div>
                </div>
                {/* CARD CONTENT-PROFILE-END */}

                {/* CARD ORDER-PAYMENT-START */}
                <div className="card profile-details">
                 <div className="card-header">
                        <h5 style={{float:'left'}} className="mb-0">Order Payments</h5>
                            <Link style={{float:'right'}} to={"#"} data-bs-toggle="modal" data-bs-target="#order_payment_edit_modal" className="btn btn-lg btn-dark mb-0">
                            Add
                            </Link>
               </div>
                <div className="table-responsive custom-table">
                <Table allow_multiple={true} table={Portal_Table.ORDER} dataSource={order_payments} columns={order_payment_list_columns} Selection={false} />
                </div>
                </div>
                <div className="card profile-details">
                <div className="card-header">
                <h5 className="mb-0">Order Items</h5>
                </div>
                <div className="table-responsive custom-table">
                <Table allow_multiple={true} table={Portal_Table.ORDER} dataSource={order_items} columns={order_item_columns} Selection={false} />
                </div>
                </div>
                <div className="card profile-details">
                <div className="card-header">
                <h5 className="mb-0">Order Sub Items</h5>
                </div>
                <div className="table-responsive custom-table">
                <Table  allow_multiple={true} table={Portal_Table.ORDER} dataSource={order_sub_items} columns={order_item_columns} Selection={false} />
                </div>
                </div>
                {/* CARD ORDER-PAYMENT-END */}


                </div>
                </div>
                </div>
                </div>
                {/* /Page Content */}
                <Order_Payment_Edit_Modal order={order} />
                <Order_Status_Edit_Modal order={order} onUpdate={updateOrderStatus} />
            </>
                );
};

export default Dashboard_Admin_Order_Detail;
